$(document).ready(function(){
  if (window.innerWidth < 768) {
         $('.desktop-video').remove();
        } else {
         $('.mobile-video').remove();
        }

  $(window).on('load', function() {
    if (window.innerWidth < 768) {
      var video1 = $('#mymobileVideo')[0];
      video1.muted = true; 
      video1.play().catch(function(error) {
          console.log('Autoplay prevented:', error);
      });
    }
    else{
      var video = $('#myVideo')[0];
      video.muted = true;
       video.play().catch(function(error) {
          console.log('Autoplay prevented:', error);
      });
    } 
});

$('#unmuteButton').on('click', function() {
    var video = $('#myVideo')[0];
    var video1 = $('#mymobileVideo')[0];
    video.muted = true; // Allow the user to unmute the video
    video1.muted = true; // Allow the user to unmute the video
});

$('#list-view-btn').click(function(){
    $(this).addClass('active');
    $('#grid-view-btn').removeClass('active');
    $('#product-grid').addClass('gridviewproduct-product-block');
  });
  $('#grid-view-btn').click(function(){
    $(this).addClass('active');
    $('#list-view-btn').removeClass('active');
    $('#product-grid').removeClass('gridviewproduct-product-block');
  })
  // collection page load more function start
  $('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[loader]').removeClass('hide');
  currentPage = currentPage+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
    },
    complete: function() {
      // if(currentPage <= totalPages) {
      //    $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
      // } 
      // Check if the current page is still less than total pages
      if(currentPage < totalPages) {
         // Re-enable the button and hide the loader
         $this.attr('disabled', false);
         $this.find('[load-more-text]').removeClass('hide');
         $this.find('[loader]').addClass('hide');
      } else {
         // If no more products, hide the button permanently
         $this.attr('disabled', true).addClass('hide'); // Optionally, hide the button completely
      }
    }
  })
});
})
